import api from '@/utils/api';

/**
 * Create option
 * @param {object} companyData - The option data
 * @param {string} companyId - the companyId
 * @returns {Promise}
 */
const createCompanyOptionApi = (companyData, companyId) =>
  api.post(`/company/${companyId}/option`, companyData);

export default createCompanyOptionApi;
